/* eslint-disable */
import { PluginContainerData, Media } from './common.js';

import {
  PollData_Poll_Settings_Permissions_ViewRole,
  PollData_Poll_Settings_Permissions_VoteRole,
  PollData_Layout_PollLayout_Type,
  PollData_Layout_PollLayout_Direction,
  PollData_Design_PollDesign_Background_Type,
} from './plugin_poll.enums.js';

export interface PollData {
  /** Styling for the poll's container. */
  containerData?: PluginContainerData;
  /** Poll data. */
  poll?: PollData_Poll;
  /** Layout settings for the poll and voting options. */
  layout?: PollData_Layout;
  /** Styling for the poll and voting options. */
  design?: PollData_Design;
}

export interface PollData_Poll {
  /** Poll ID. */
  id?: string;
  /** Poll title. */
  title?: string;
  /** Poll creator ID. */
  creatorId?: string;
  /** Main poll image. */
  image?: Media;
  /** Voting options. */
  options: PollData_Poll_Option[];
  /** The poll's permissions and display settings. */
  settings?: PollData_Poll_Settings;
}

export interface PollData_Poll_Option {
  /** Option ID. */
  id?: string;
  /** Option title. */
  title?: string;
  /** The image displayed with the option. */
  image?: Media;
}

export interface PollData_Poll_Settings {
  /** Permissions settings for voting. */
  permissions?: PollData_Poll_Settings_Permissions;
  /** Sets whether voters are displayed in the vote results. Defaults to `true`. */
  showVoters?: boolean;
  /** Sets whether the vote count is displayed. Defaults to `true`. */
  showVotesCount?: boolean;
}

export interface PollData_Poll_Settings_Permissions {
  /** Sets who can view the poll results. */
  view: PollData_Poll_Settings_Permissions_ViewRole;
  /** Sets who can vote. */
  vote: PollData_Poll_Settings_Permissions_VoteRole;
  /** Sets whether one voter can vote multiple times. Defaults to `false`. */
  allowMultipleVotes?: boolean;
}

export function pollData_Poll_Settings_Permissions_ViewRoleFromJSON(
  object: any
): PollData_Poll_Settings_Permissions_ViewRole {
  switch (object) {
    case 0:
    case "CREATOR":
      return PollData_Poll_Settings_Permissions_ViewRole.CREATOR;
    case 1:
    case "VOTERS":
      return PollData_Poll_Settings_Permissions_ViewRole.VOTERS;
    case 2:
    case "EVERYONE":
      return PollData_Poll_Settings_Permissions_ViewRole.EVERYONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PollData_Poll_Settings_Permissions_ViewRole.UNRECOGNIZED;
  }
}

export function pollData_Poll_Settings_Permissions_ViewRoleToJSON(
  object: PollData_Poll_Settings_Permissions_ViewRole
): string {
  switch (object) {
    case PollData_Poll_Settings_Permissions_ViewRole.CREATOR:
      return "CREATOR";
    case PollData_Poll_Settings_Permissions_ViewRole.VOTERS:
      return "VOTERS";
    case PollData_Poll_Settings_Permissions_ViewRole.EVERYONE:
      return "EVERYONE";
    default:
      return "UNKNOWN";
  }
}

export function pollData_Poll_Settings_Permissions_VoteRoleFromJSON(
  object: any
): PollData_Poll_Settings_Permissions_VoteRole {
  switch (object) {
    case 0:
    case "SITE_MEMBERS":
      return PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS;
    case 1:
    case "ALL":
      return PollData_Poll_Settings_Permissions_VoteRole.ALL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PollData_Poll_Settings_Permissions_VoteRole.UNRECOGNIZED;
  }
}

export function pollData_Poll_Settings_Permissions_VoteRoleToJSON(
  object: PollData_Poll_Settings_Permissions_VoteRole
): string {
  switch (object) {
    case PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS:
      return "SITE_MEMBERS";
    case PollData_Poll_Settings_Permissions_VoteRole.ALL:
      return "ALL";
    default:
      return "UNKNOWN";
  }
}

export interface PollData_Layout {
  /** Poll layout settings. */
  poll?: PollData_Layout_PollLayout;
  /** Voting otpions layout settings. */
  options?: PollData_Layout_OptionLayout;
}

export interface PollData_Layout_PollLayout {
  /** The layout for displaying the voting options. */
  type: PollData_Layout_PollLayout_Type;
  /** The direction of the text displayed in the voting options. Text can be displayed either right-to-left or left-to-right. */
  direction: PollData_Layout_PollLayout_Direction;
  /** Sets whether to display the main poll image. Defaults to `false`. */
  enableImage?: boolean;
}

export function pollData_Layout_PollLayout_TypeFromJSON(
  object: any
): PollData_Layout_PollLayout_Type {
  switch (object) {
    case 0:
    case "LIST":
      return PollData_Layout_PollLayout_Type.LIST;
    case 1:
    case "GRID":
      return PollData_Layout_PollLayout_Type.GRID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PollData_Layout_PollLayout_Type.UNRECOGNIZED;
  }
}

export function pollData_Layout_PollLayout_TypeToJSON(
  object: PollData_Layout_PollLayout_Type
): string {
  switch (object) {
    case PollData_Layout_PollLayout_Type.LIST:
      return "LIST";
    case PollData_Layout_PollLayout_Type.GRID:
      return "GRID";
    default:
      return "UNKNOWN";
  }
}

export function pollData_Layout_PollLayout_DirectionFromJSON(
  object: any
): PollData_Layout_PollLayout_Direction {
  switch (object) {
    case 0:
    case "LTR":
      return PollData_Layout_PollLayout_Direction.LTR;
    case 1:
    case "RTL":
      return PollData_Layout_PollLayout_Direction.RTL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PollData_Layout_PollLayout_Direction.UNRECOGNIZED;
  }
}

export function pollData_Layout_PollLayout_DirectionToJSON(
  object: PollData_Layout_PollLayout_Direction
): string {
  switch (object) {
    case PollData_Layout_PollLayout_Direction.LTR:
      return "LTR";
    case PollData_Layout_PollLayout_Direction.RTL:
      return "RTL";
    default:
      return "UNKNOWN";
  }
}

export interface PollData_Layout_OptionLayout {
  /** Sets whether to display option images. Defaults to `false`. */
  enableImage?: boolean;
}

export interface PollData_Design {
  /** Styling for the poll. */
  poll?: PollData_Design_PollDesign;
  /** Styling for voting options. */
  options?: PollData_Design_OptionDesign;
}

export interface PollData_Design_PollDesign {
  /** Background styling. */
  background?: PollData_Design_PollDesign_Background;
  /** Border radius in pixels. */
  borderRadius?: number;
}

export interface PollData_Design_PollDesign_Background {
  /** Background type. For each option, include the relevant details. */
  type: PollData_Design_PollDesign_Background_Type;
  /** The background color as a hexademical value. */
  color?: string;
  /** An image to use for the background. */
  image?: Media | undefined;
  /** Details for a gradient background. */
  gradient?: PollData_Design_PollDesign_Background_Gradient | undefined;
}

export function pollData_Design_PollDesign_Background_TypeFromJSON(
  object: any
): PollData_Design_PollDesign_Background_Type {
  switch (object) {
    case 0:
    case "COLOR":
      return PollData_Design_PollDesign_Background_Type.COLOR;
    case 1:
    case "IMAGE":
      return PollData_Design_PollDesign_Background_Type.IMAGE;
    case 2:
    case "GRADIENT":
      return PollData_Design_PollDesign_Background_Type.GRADIENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PollData_Design_PollDesign_Background_Type.UNRECOGNIZED;
  }
}

export function pollData_Design_PollDesign_Background_TypeToJSON(
  object: PollData_Design_PollDesign_Background_Type
): string {
  switch (object) {
    case PollData_Design_PollDesign_Background_Type.COLOR:
      return "COLOR";
    case PollData_Design_PollDesign_Background_Type.IMAGE:
      return "IMAGE";
    case PollData_Design_PollDesign_Background_Type.GRADIENT:
      return "GRADIENT";
    default:
      return "UNKNOWN";
  }
}

export interface PollData_Design_PollDesign_Background_Gradient {
  /** The gradient angle in degrees. */
  angle?: number;
  /** The start color as a hexademical value. */
  startColor?: string;
  /** The end color as a hexademical value. */
  lastColor?: string;
}

export interface PollData_Design_OptionDesign {
  /** Border radius in pixels. */
  borderRadius?: number;
}

const basePollData: object = {};

export const PollData = {
  fromJSON(object: any): PollData {
    const message = { ...basePollData } as PollData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.poll =
      object.poll !== undefined && object.poll !== null
        ? PollData_Poll.fromJSON(object.poll)
        : undefined;
    message.layout =
      object.layout !== undefined && object.layout !== null
        ? PollData_Layout.fromJSON(object.layout)
        : undefined;
    message.design =
      object.design !== undefined && object.design !== null
        ? PollData_Design.fromJSON(object.design)
        : undefined;
    return message;
  },

  toJSON(message: PollData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.poll !== undefined &&
      (obj.poll = message.poll
        ? PollData_Poll.toJSON(message.poll)
        : undefined);
    message.layout !== undefined &&
      (obj.layout = message.layout
        ? PollData_Layout.toJSON(message.layout)
        : undefined);
    message.design !== undefined &&
      (obj.design = message.design
        ? PollData_Design.toJSON(message.design)
        : undefined);
    return obj;
  },
};

const basePollData_Poll: object = {};

export const PollData_Poll = {
  fromJSON(object: any): PollData_Poll {
    const message = { ...basePollData_Poll } as PollData_Poll;
    message.id =
      object.id !== undefined && object.id !== null
        ? String(object.id)
        : undefined;
    message.title =
      object.title !== undefined && object.title !== null
        ? String(object.title)
        : undefined;
    message.creatorId =
      object.creatorId !== undefined && object.creatorId !== null
        ? String(object.creatorId)
        : undefined;
    message.image =
      object.image !== undefined && object.image !== null
        ? Media.fromJSON(object.image)
        : undefined;
    message.options = (object.options ?? []).map((e: any) =>
      PollData_Poll_Option.fromJSON(e)
    );
    message.settings =
      object.settings !== undefined && object.settings !== null
        ? PollData_Poll_Settings.fromJSON(object.settings)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Poll): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.title !== undefined && (obj.title = message.title);
    message.creatorId !== undefined && (obj.creatorId = message.creatorId);
    message.image !== undefined &&
      (obj.image = message.image ? Media.toJSON(message.image) : undefined);
    if (message.options) {
      obj.options = message.options.map((e) =>
        e ? PollData_Poll_Option.toJSON(e) : undefined
      );
    } else {
      obj.options = [];
    }
    message.settings !== undefined &&
      (obj.settings = message.settings
        ? PollData_Poll_Settings.toJSON(message.settings)
        : undefined);
    return obj;
  },
};

const basePollData_Poll_Option: object = {};

export const PollData_Poll_Option = {
  fromJSON(object: any): PollData_Poll_Option {
    const message = { ...basePollData_Poll_Option } as PollData_Poll_Option;
    message.id =
      object.id !== undefined && object.id !== null
        ? String(object.id)
        : undefined;
    message.title =
      object.title !== undefined && object.title !== null
        ? String(object.title)
        : undefined;
    message.image =
      object.image !== undefined && object.image !== null
        ? Media.fromJSON(object.image)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Poll_Option): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.title !== undefined && (obj.title = message.title);
    message.image !== undefined &&
      (obj.image = message.image ? Media.toJSON(message.image) : undefined);
    return obj;
  },
};

const basePollData_Poll_Settings: object = {};

export const PollData_Poll_Settings = {
  fromJSON(object: any): PollData_Poll_Settings {
    const message = { ...basePollData_Poll_Settings } as PollData_Poll_Settings;
    message.permissions =
      object.permissions !== undefined && object.permissions !== null
        ? PollData_Poll_Settings_Permissions.fromJSON(object.permissions)
        : undefined;
    message.showVoters =
      object.showVoters !== undefined && object.showVoters !== null
        ? Boolean(object.showVoters)
        : undefined;
    message.showVotesCount =
      object.showVotesCount !== undefined && object.showVotesCount !== null
        ? Boolean(object.showVotesCount)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Poll_Settings): unknown {
    const obj: any = {};
    message.permissions !== undefined &&
      (obj.permissions = message.permissions
        ? PollData_Poll_Settings_Permissions.toJSON(message.permissions)
        : undefined);
    message.showVoters !== undefined && (obj.showVoters = message.showVoters);
    message.showVotesCount !== undefined &&
      (obj.showVotesCount = message.showVotesCount);
    return obj;
  },
};

const basePollData_Poll_Settings_Permissions: object = {
  view: PollData_Poll_Settings_Permissions_ViewRole.CREATOR,
  vote: PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS,
};

export const PollData_Poll_Settings_Permissions = {
  fromJSON(object: any): PollData_Poll_Settings_Permissions {
    const message = {
      ...basePollData_Poll_Settings_Permissions,
    } as PollData_Poll_Settings_Permissions;
    message.view =
      object.view !== undefined && object.view !== null
        ? pollData_Poll_Settings_Permissions_ViewRoleFromJSON(object.view)
        : PollData_Poll_Settings_Permissions_ViewRole.CREATOR;
    message.vote =
      object.vote !== undefined && object.vote !== null
        ? pollData_Poll_Settings_Permissions_VoteRoleFromJSON(object.vote)
        : PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS;
    message.allowMultipleVotes =
      object.allowMultipleVotes !== undefined &&
      object.allowMultipleVotes !== null
        ? Boolean(object.allowMultipleVotes)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Poll_Settings_Permissions): unknown {
    const obj: any = {};
    message.view !== undefined &&
      (obj.view = pollData_Poll_Settings_Permissions_ViewRoleToJSON(
        message.view
      ));
    message.vote !== undefined &&
      (obj.vote = pollData_Poll_Settings_Permissions_VoteRoleToJSON(
        message.vote
      ));
    message.allowMultipleVotes !== undefined &&
      (obj.allowMultipleVotes = message.allowMultipleVotes);
    return obj;
  },
};

const basePollData_Layout: object = {};

export const PollData_Layout = {
  fromJSON(object: any): PollData_Layout {
    const message = { ...basePollData_Layout } as PollData_Layout;
    message.poll =
      object.poll !== undefined && object.poll !== null
        ? PollData_Layout_PollLayout.fromJSON(object.poll)
        : undefined;
    message.options =
      object.options !== undefined && object.options !== null
        ? PollData_Layout_OptionLayout.fromJSON(object.options)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Layout): unknown {
    const obj: any = {};
    message.poll !== undefined &&
      (obj.poll = message.poll
        ? PollData_Layout_PollLayout.toJSON(message.poll)
        : undefined);
    message.options !== undefined &&
      (obj.options = message.options
        ? PollData_Layout_OptionLayout.toJSON(message.options)
        : undefined);
    return obj;
  },
};

const basePollData_Layout_PollLayout: object = {
  type: PollData_Layout_PollLayout_Type.LIST,
  direction: PollData_Layout_PollLayout_Direction.LTR,
};

export const PollData_Layout_PollLayout = {
  fromJSON(object: any): PollData_Layout_PollLayout {
    const message = {
      ...basePollData_Layout_PollLayout,
    } as PollData_Layout_PollLayout;
    message.type =
      object.type !== undefined && object.type !== null
        ? pollData_Layout_PollLayout_TypeFromJSON(object.type)
        : PollData_Layout_PollLayout_Type.LIST;
    message.direction =
      object.direction !== undefined && object.direction !== null
        ? pollData_Layout_PollLayout_DirectionFromJSON(object.direction)
        : PollData_Layout_PollLayout_Direction.LTR;
    message.enableImage =
      object.enableImage !== undefined && object.enableImage !== null
        ? Boolean(object.enableImage)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Layout_PollLayout): unknown {
    const obj: any = {};
    message.type !== undefined &&
      (obj.type = pollData_Layout_PollLayout_TypeToJSON(message.type));
    message.direction !== undefined &&
      (obj.direction = pollData_Layout_PollLayout_DirectionToJSON(
        message.direction
      ));
    message.enableImage !== undefined &&
      (obj.enableImage = message.enableImage);
    return obj;
  },
};

const basePollData_Layout_OptionLayout: object = {};

export const PollData_Layout_OptionLayout = {
  fromJSON(object: any): PollData_Layout_OptionLayout {
    const message = {
      ...basePollData_Layout_OptionLayout,
    } as PollData_Layout_OptionLayout;
    message.enableImage =
      object.enableImage !== undefined && object.enableImage !== null
        ? Boolean(object.enableImage)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Layout_OptionLayout): unknown {
    const obj: any = {};
    message.enableImage !== undefined &&
      (obj.enableImage = message.enableImage);
    return obj;
  },
};

const basePollData_Design: object = {};

export const PollData_Design = {
  fromJSON(object: any): PollData_Design {
    const message = { ...basePollData_Design } as PollData_Design;
    message.poll =
      object.poll !== undefined && object.poll !== null
        ? PollData_Design_PollDesign.fromJSON(object.poll)
        : undefined;
    message.options =
      object.options !== undefined && object.options !== null
        ? PollData_Design_OptionDesign.fromJSON(object.options)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Design): unknown {
    const obj: any = {};
    message.poll !== undefined &&
      (obj.poll = message.poll
        ? PollData_Design_PollDesign.toJSON(message.poll)
        : undefined);
    message.options !== undefined &&
      (obj.options = message.options
        ? PollData_Design_OptionDesign.toJSON(message.options)
        : undefined);
    return obj;
  },
};

const basePollData_Design_PollDesign: object = {};

export const PollData_Design_PollDesign = {
  fromJSON(object: any): PollData_Design_PollDesign {
    const message = {
      ...basePollData_Design_PollDesign,
    } as PollData_Design_PollDesign;
    message.background =
      object.background !== undefined && object.background !== null
        ? PollData_Design_PollDesign_Background.fromJSON(object.background)
        : undefined;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Design_PollDesign): unknown {
    const obj: any = {};
    message.background !== undefined &&
      (obj.background = message.background
        ? PollData_Design_PollDesign_Background.toJSON(message.background)
        : undefined);
    message.borderRadius !== undefined &&
      (obj.borderRadius = message.borderRadius);
    return obj;
  },
};

const basePollData_Design_PollDesign_Background: object = {
  type: PollData_Design_PollDesign_Background_Type.COLOR,
};

export const PollData_Design_PollDesign_Background = {
  fromJSON(object: any): PollData_Design_PollDesign_Background {
    const message = {
      ...basePollData_Design_PollDesign_Background,
    } as PollData_Design_PollDesign_Background;
    message.type =
      object.type !== undefined && object.type !== null
        ? pollData_Design_PollDesign_Background_TypeFromJSON(object.type)
        : PollData_Design_PollDesign_Background_Type.COLOR;
    message.color =
      object.color !== undefined && object.color !== null
        ? String(object.color)
        : undefined;
    message.image =
      object.image !== undefined && object.image !== null
        ? Media.fromJSON(object.image)
        : undefined;
    message.gradient =
      object.gradient !== undefined && object.gradient !== null
        ? PollData_Design_PollDesign_Background_Gradient.fromJSON(
            object.gradient
          )
        : undefined;
    return message;
  },

  toJSON(message: PollData_Design_PollDesign_Background): unknown {
    const obj: any = {};
    message.type !== undefined &&
      (obj.type = pollData_Design_PollDesign_Background_TypeToJSON(
        message.type
      ));
    message.color !== undefined && (obj.color = message.color);
    message.image !== undefined &&
      (obj.image = message.image ? Media.toJSON(message.image) : undefined);
    message.gradient !== undefined &&
      (obj.gradient = message.gradient
        ? PollData_Design_PollDesign_Background_Gradient.toJSON(
            message.gradient
          )
        : undefined);
    return obj;
  },
};

const basePollData_Design_PollDesign_Background_Gradient: object = {};

export const PollData_Design_PollDesign_Background_Gradient = {
  fromJSON(object: any): PollData_Design_PollDesign_Background_Gradient {
    const message = {
      ...basePollData_Design_PollDesign_Background_Gradient,
    } as PollData_Design_PollDesign_Background_Gradient;
    message.angle =
      object.angle !== undefined && object.angle !== null
        ? Number(object.angle)
        : undefined;
    message.startColor =
      object.startColor !== undefined && object.startColor !== null
        ? String(object.startColor)
        : undefined;
    message.lastColor =
      object.lastColor !== undefined && object.lastColor !== null
        ? String(object.lastColor)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Design_PollDesign_Background_Gradient): unknown {
    const obj: any = {};
    message.angle !== undefined && (obj.angle = message.angle);
    message.startColor !== undefined && (obj.startColor = message.startColor);
    message.lastColor !== undefined && (obj.lastColor = message.lastColor);
    return obj;
  },
};

const basePollData_Design_OptionDesign: object = {};

export const PollData_Design_OptionDesign = {
  fromJSON(object: any): PollData_Design_OptionDesign {
    const message = {
      ...basePollData_Design_OptionDesign,
    } as PollData_Design_OptionDesign;
    message.borderRadius =
      object.borderRadius !== undefined && object.borderRadius !== null
        ? Number(object.borderRadius)
        : undefined;
    return message;
  },

  toJSON(message: PollData_Design_OptionDesign): unknown {
    const obj: any = {};
    message.borderRadius !== undefined &&
      (obj.borderRadius = message.borderRadius);
    return obj;
  },
};
